<script lang="ts">
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Components
	import NightSchedule from '../NightModeComponents/NightSchedule.svelte';
	import NightModeListV2 from '../NightModeComponents/NightModeListV2.svelte';
	import NightModeDeviceOffAlert from '../NightModeComponents/NightModeDeviceOffAlert.svelte';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	// Types
	import type { InputClickEvent } from 'src/types/InputClickEvent';

	export let device;

	let props = {
		start: $settingsStore.night_mode.start_time,
		end: $settingsStore.night_mode.end_time,
		brightness: $settingsStore.night_mode.brightness,
	};

	let checked = $settingsStore.night_mode.enabled;

	let nightMode = {
		active_between: [props.start, props.end],
		brightness: props.brightness,
	};

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;

	let local_ip = get_local_ip(device.id);
	let showModal = false;

	const setNightMode = async () => {
		let res;
		let data = {
			id: device.id,
			enabled: checked ? 1 : 0,
			start_time: props.start,
			end_time: props.end,
			brightness: props.brightness,
		};

		if (local_ip) {
			delete data.id;
			res = await localReq(device, `${local_ip}/settings/night_mode`, 'post', data);
		} else {
			res = await postReq(`/device/${device.category}/settings/night_mode`, data);
		}

		if (res.isok) {
			settings.night_mode = props;
			settings.night_mode.enabled = checked;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title: checked
					? $format('night_mode_successfully_saved')
					: $format('night_mode_disabled'),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};

	const handleToggler = async (e: InputClickEvent) => {
		checked = e.target.checked;
		setNightMode();
	};

	const handleSave = (e) => {
		const _nightMode = { ...e.detail };
		nightMode.active_between = [_nightMode.start, _nightMode.end];
		nightMode.brightness = _nightMode.brightness;
		setNightMode();
		props = {
			start: nightMode['active_between'][0],
			end: nightMode['active_between'][1],
			brightness: nightMode.brightness,
		};
	};
</script>

<Toggle size="l" {checked} on:click={handleToggler} id="toggle-u6px2et-v2">
	{$format('label_enable_night_mode')}
</Toggle>

<NightModeDeviceOffAlert enabled={checked} />

<hr class="mb-m mt-s" />

{#key checked}
	<NightModeListV2 disabled={!checked} {nightMode} on:edit={() => (showModal = true)} />
{/key}

{#if showModal}
	<NightSchedule {props} deviceType={device.type} bind:showModal on:save={handleSave} />
{/if}
